<template>
    <div class="container">
    </div>
</template>


<script>
export default ({
    data() {
        return {
            id: -1,
            gender: -1,
            token: ''
        }
    },

    created() {
        // console.log('can it be created si- - - - - - - >');
        this.checkURLParams();
    },

    methods: {
        checkURLParams() {
            const url = window.location.href;
            const z = url.split('?');
            let p = {};
            try {
                const k = z[1].split('&');
                k.forEach(item => {
                    const m = item.split('=');
                    p[m[0]] = m[1];
                })
                this.id = p.id;
                this.gender = p.gender;
                this.token = p.token;
            } catch(e) {}
        },

        click(page) {
            // alert(this.token);
            // console.log('tiktok tiktok really - - - - - - >', this.token);
            // return;
            const p = {};
            // p.page = 'FreeChat';
            p.page = page;
            p.id = '214791';
            p.data = {};
            // p.tt = this.id;
            // p.hh = this.gender;
            const z = JSON.stringify(p);
            window.ReactNativeWebView.postMessage(z);
        },

        goHome() {
            window.location.href = '/event-qixi';
        }
    }
})
</script>



<style scoped>
.container {
    width: 100vw;
    height: 200vw;
    display: flex;
    background-image: url(https://app-1301744297.file.myqcloud.com/static/vip/vip_namecolor_up.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-color: rgb(255, 246, 234);
}
</style>